import {
	Legend,
	PolarAngleAxis,
	PolarGrid,
	PolarRadiusAxis,
	Radar,
	RadarChart
} from "recharts";

import styles from "../DesafioPratico.module.css";

function RadarGraph({ data, group }) {
	function isColliding(a, b, padding = 10) {
		return !(
			a.x + a.width + padding < b.x ||
			a.x > b.x + b.width + padding ||
			a.y + a.height + padding < b.y ||
			a.y > b.y + b.height + padding
		);
	}

	const RadarAngleTick = (() => {
		const placed = [];

		return ({ payload, x, y, cx, cy }) => {
			let offset = 15;
			let attempts = 0;

			const dx = x - cx;
			const dy = y - cy;
			const len = Math.sqrt(dx * dx + dy * dy);
			const nx = dx / len;
			const ny = dy / len;

			let finalX, finalY;
			let bbox;

			do {
				finalX = x + nx * offset;
				finalY = y + ny * offset;

				// estimativa de bounding box (SVG não expõe antes do render)
				bbox = {
					x: finalX - payload.value.length * 3.5,
					y: finalY - 8,
					width: payload.value.length * 7,
					height: 8,
				};

				const collision = placed.some(p => isColliding(bbox, p));
				if (!collision) break;

				offset += 10;   // empurra mais para fora
				attempts += 1;
			} while (attempts < 5);

			placed.push(bbox);

			return (
				<text
					x={finalX}
					y={finalY}
					textAnchor="middle"
				>
					{payload.value}
				</text>
			);
		};
	})();


	return (
		<div className={`w-full flex justify-center ${styles.chartContainerPadding}`}>
			<RadarChart
				cx={400}
				cy={300}
				outerRadius={150}
				width={800}
				height={600}
				data={data}
			>
				<PolarAngleAxis dataKey="skill" />
				<PolarGrid stroke="#6e6e6eff" gridType="polygon" />
				<PolarRadiusAxis
					angle={90}
					domain={[0, 10]}
					dy={15}
					stroke="#0c0c0cff"
				/>

				{/* Linha Azul - Média do Grupo */}
				<Radar
					name={`Média do Grupo (${group})`}
					dataKey="grade"
					stroke="#10284e"
					strokeWidth={2.5}
					dot={true}
					fillOpacity={0}
				/>

                {/* Linha Amarela - Média da Turma */}
				<Radar
					name="Média da Turma"
					dataKey="class_grade"
					stroke="#f2c744"
					strokeWidth={2.5}
					dot={true}
					fillOpacity={0}
				/>

				<Legend iconType="circle" />
			</RadarChart>
		</div>
	);
}

export default RadarGraph;
